import { NgModule } from '@angular/core';

import { ListEditorComponent } from './list-editor.component';

/**
 * @ignore
 */
@NgModule({
  declarations: [ListEditorComponent],
  imports: [],
  exports: [ListEditorComponent]
})
export class NguixDashboardListEditorComponentModule {}
